import axios from 'axios';
import { URL_COUNTRY_WORK_PROFILE } from '../constants/urls';

export const FETCH_COUNTRY_WORK_PROFILE_BEGIN =
  'FETCH_COUNTRY_WORK_PROFILE_BEGIN';
export const FETCH_COUNTRY_WORK_PROFILE_SUCCESS =
  'FETCH_COUNTRY_WORK_PROFILE_SUCCESS';
export const FETCH_COUNTRY_WORK_PROFILE_FAILURE =
  'FETCH_COUNTRY_WORK_PROFILE_FAILURE';

export const fetchCountryWorkProfile = () => async (dispatch) => {
  dispatch({ type: FETCH_COUNTRY_WORK_PROFILE_BEGIN });

  try {
    const response = await axios.get(URL_COUNTRY_WORK_PROFILE);

    dispatch({
      payload: response.data,
      type: FETCH_COUNTRY_WORK_PROFILE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      payload: error.message,
      type: FETCH_COUNTRY_WORK_PROFILE_FAILURE,
    });
  }
};
